import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';
import * as jsonCP from '../../../../../assets/validators/cp.json';

export class CTRL_268 implements Validator {

	public static id = 'CTRL_268';
	private message = 'error.ctr_268';


	public LOG: LogService = new LogService(CTRL_268);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_268.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];

				const firstWithStepId = map.get(ctrl.value.rgCtrls.firstChamp); // 01
				const secondWithStepId = map.get(ctrl.value.rgCtrls.secondChamp); //01001
				const firstCtrl = form.controls[firstWithStepId];
				const secondCtrl = form.controls[secondWithStepId];
				if (this.isEmptyOrNullOrUndefined(firstCtrl) ||
					this.isEmptyOrNullOrUndefined(secondCtrl)) {
						form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidationWarning: false };
				} else {
					let countCP = jsonCP.cp.filter(cp => cp.codeDepartement === secondCtrl.value.substring(0,2) && cp.codeCommune === secondCtrl.value.substring(2,5)).length;
					if ( firstCtrl.value !== secondCtrl.value.substring(0,2) || countCP === 0) {
						// placer le message d'erreur
						form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidationWarning: true, validation_message: this.message };
					} else {
						form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidationWarning: false };
					}
				}
				
			}
		}
	}

	isEmptyOrNullOrUndefined(ctrl): boolean {
		return (ctrl === undefined || ctrl === null || ctrl.value === undefined || ctrl.value === null || ctrl.value === '');
	}
}
